"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var react_router_1 = require("react-router");
var Payment_1 = require("../../../commonSteps/payment/components/Payment");
var JourneyStepsRoutes_1 = require("../../enum/JourneyStepsRoutes");
var UrlParamTypes_1 = require("../../../../common/enum/UrlParamTypes");
var useUrlDealId_1 = require("../../../common/hooks/useUrlDealId");
var paymentPageStyles_1 = require("./paymentPageStyles");
var PaymentPage = function (_a) {
    var deal = _a.deal;
    var history = react_router_1.useHistory();
    var token = useUrlDealId_1.default();
    var styles = paymentPageStyles_1.default();
    var goToNextStep = react_1.useCallback(function () {
        history.replace({
            pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.CONFIRMATION,
            search: "?" + UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token,
        });
    }, []);
    return (<core_1.Container data-test={'container:checkout:payment'} className={styles.container}>
      <Payment_1.default goToNextStep={goToNextStep} deal={deal}/>
    </core_1.Container>);
};
exports.default = PaymentPage;
